import React from "react";
import "./style.scss";
import { Modal } from "react-bootstrap";
import HotelItemWebLink from "../HotelItem/ListViewCardWebLink";
import HotelItemWebLinkSmall from "../HotelItem/ListViewCardWebLinkSmall";
import PropTypes from "prop-types";

// Parallel Web Link version of HotelItemCardModal. Renders the decoded flat
// share data (sharedData) instead of the redux branchData. The Branch modal is
// left untouched.
const HotelItemCardWebLinkModal = ({ sharedData, onClose }) => {
    return (
        <Modal className="hotelcard-modal" centered show={!!sharedData}
            onHide={() => onClose && onClose()} backdrop="static">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="for-dekstop">
                    <HotelItemWebLink offer={sharedData} />
                </div>
                <div className="for-small">
                    <HotelItemWebLinkSmall offer={sharedData} />
                </div>
            </Modal.Body>
        </Modal>
    );
};

HotelItemCardWebLinkModal.propTypes = {
    sharedData: PropTypes.object,
    onClose: PropTypes.func,
};

export default HotelItemCardWebLinkModal;
